<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-layout wrap>
            <v-flex xs12>
                <v-switch v-model="item.enable" label="Habilitado" color="success" inset />
            </v-flex>
            <v-flex xs6>
                <v-text-field label="Nome" v-model="item.name" :rules="[rules.required]" />
            </v-flex>
            <v-flex xs6>
                <v-autocomplete v-model="item.server" :items="servers" item-value="id" item-text="name" label="Integração no Servidor" :rules="[rules.required]" :disabled="item.id" @change="removeUnavailableChargers" />
            </v-flex>
            <v-flex xs12>
                <v-autocomplete v-model="item.chargers" :rules="[rules.required]" :items="filteredChargerList" item-value="id" item-text="name" label="Carregadores" deletable-chips
                    multiple small-chips :disabled="!item.server" />
            </v-flex>
            <v-flex xs12 v-if="excludedChargers.length">
                <v-alert type="error" dense>
                    Os seguintes carregadores foram removidos automaticamente por não estarem mais disponíveis no servidor selecionado:
                    <br>
                    {{ excludedChargers.join(", ") }}
                </v-alert>
            </v-flex>

            <v-flex xs12>
                <v-card elevation="2" class="pa-4 mb-4">
                    <v-card-title class="pa-0 mb-4">
                        <v-icon color="primary" class="mr-2">settings</v-icon>
                        <span class="text-h6">Acesso API de dados</span>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-alert type="info" dense outlined>
                                    O token deve ser gerado caso o processo de credenciamento for iniciado pelo parceiro. Esse token (Token A) deve ser compartilhado com o parceiro e só permite acessar os módulos de versões e credenciais.
                                    <br>
                                    <br>
                                    Após o credenciamento, este campo passa a exibir o token que o parceiro usa para acessar a API (Token C). Ele não deve ser alterado, caso contrário o parceiro perderá o acesso à API.
                                </v-alert>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Token" v-model="item.api.token" min="8" append-icon="refresh" type="text" @click:append="generateApiKey" required />
                            </v-flex>

                            <v-flex xs12>
                                <v-divider class="my-3" />
                                <h4 class="mb-3">
                                    <v-icon small>vpn_key</v-icon>
                                    Permissões da API
                                </h4>
                            </v-flex>

                            <v-flex xs12 md6>
                                <v-switch v-model="item.api.canStartSession" label="Permitir iniciar sessão" color="success" :true-value="true" :false-value="false" inset
                                    hint="Permite que a API inicie sessões de carregamento" persistent-hint />
                            </v-flex>

                            <v-flex xs12 md6>
                                <v-switch v-model="item.api.canStopSession" label="Permitir parar sessão" color="error" :true-value="true" :false-value="false" inset
                                    hint="Permite que a API pare sessões de carregamento" persistent-hint />
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12>
                <v-card elevation="2" class="pa-4 mb-4">
                    <v-card-title class="pa-0 mb-4">
                        <v-icon color="primary" class="mr-2">dns</v-icon>
                        <span class="text-h6">Dados do servidor do parceiro</span>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-card outlined class="pa-3">
                            <v-layout row wrap>
                            <v-flex xs12>
                                <v-alert type="info" dense outlined>
                                    O token gerado pelo parceiro deve ser preenchido quando o processo de troca de credencial for iniciado pelo servidor da INCHARGE. Após o credenciamento, este campo passa a exibir o token que a INCHARGE usa para acessar a API do parceiro.
                                    <br>
                                    <br>
                                    A URL deve ser a base do OCPI do parceiro: o endpoint de versões é buscado em {URL}/versions.
                                </v-alert>
                            </v-flex>
                                <v-flex xs12>
                                    <v-switch v-model="item.finishCredentials" label="Troca de credencias feita" color="success" inset disabled />
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-text-field v-model="item.partnerServer.url" label="URL do servidor" placeholder="https://parceiro.com.br/ocpi"
                                        :rules="[rules.required]" />
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-text-field v-model="item.partnerServer.token" label="Token gerado pelo parceiro"
                                        placeholder="Token gerado pelo parceiro (pode deixar vazio)" />
                                </v-flex>
                            </v-layout>
                        </v-card>

                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12>
                <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate" style="width: 100%;">Salvar</v-btn>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

import servers from "@/assets/json/servers.json";

export default {
    directives: { mask },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            chargerList: [],
            excludedChargers: [],
            chargersLoaded: false,
            itemClean: {
                name: "",
                server: null,
                api: {
                    token: "",
                    canStartSession: false,
                    canStopSession: false,
                },
                chargers: [],
                partnerServer: {
                    url: "",
                    token: "",
                },
                enable: true,
                finishCredentials: false,
            },
            item: { ...this.itemClean },
            servers,
        };
    },

    mounted() {
        this.$http
            .get("api/v2/charger")
            .then((result) => {
                this.chargerList = result;
                this.chargersLoaded = true;
                this.removeUnavailableChargers();
            })
            .catch(() => {
                this.chargerList = [];
                this.chargersLoaded = true;
                this.removeUnavailableChargers();
            });
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                if (newVal == null) {
                    this.item = { ...this.itemClean };
                    this.excludedChargers = [];
                } else {
                    this.item = { ...newVal };
                    if (!Array.isArray(this.item.chargers)) {
                        this.item.chargers = [];
                    }
                    this.excludedChargers = [];
                    this.removeUnavailableChargers();
                }
            },
        },
    },

    computed: {
        filteredChargerList() {
            if (!this.item.server) return this.chargerList;
            return this.chargerList.filter((c) => c.server === this.item.server);
        },
    },

    methods: {
        removeUnavailableChargers() {
            if (!this.chargersLoaded || !this.item) return;

            const selectedChargers = Array.isArray(this.item.chargers)
                ? this.item.chargers
                : [];

            if (!selectedChargers.length) {
                this.excludedChargers = [];
                return;
            }

            const availableIds = new Set(this.filteredChargerList.map((charger) => String(charger.id)));
            const validChargers = selectedChargers.filter((id) => availableIds.has(String(id)));
            const removedChargers = selectedChargers.filter((id) => !availableIds.has(String(id)));

            this.item.chargers = validChargers;
            this.excludedChargers = removedChargers.map((id) => {
                const charger = this.chargerList.find((c) => String(c.id) === String(id));
                return charger ? `${charger.name}` : `ID ${id}`;
            });
        },

        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
        async generateApiKey() {
            const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const randomValues = new Uint8Array(64);
            window.crypto.getRandomValues(randomValues);
            this.item.api.token = Array.from(randomValues).map((v) => charset[v % charset.length]).join('');

            // Copia para a área de transferência
            navigator.clipboard.writeText(this.item.api.token)
                .then(() => {
                    this.$eventHub.$emit("msgSuccess", 'Chave de acesso copiada para a área de transferência.');
                });
        },
    },
};
</script>